import { MessageCircle } from "lucide-react";
import WhatsApp from "@/components/ui/WhatsApp";

import Logo from "@/components/ui/Logo";
import React from "react";

interface HeaderType {
  navegation?: string[];
}

const Header = ({ navegation }: HeaderType) => {
  return (
    <header
      id="header"
      className="border-border/50 bg-background/80 fixed top-0 right-0 left-0 z-50 border-b backdrop-blur-md"
    >
      <section className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {navegation?.map((item, index) => (
            <a
              className="text-muted-foreground hover:text-foreground text-sm font-medium transition-colors"
              href={`#${item}`}
              key={index}
            >
              {item}
            </a>
          ))}
          <WhatsApp className="bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/20 inline-flex cursor-pointer items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-all hover:shadow-lg" />
        </nav>
      </section>
    </header>
  );
};

export default Header;
